// extracted by mini-css-extract-plugin
export default {"container":"Order_container__r8IVx","leftSide":"Order_leftSide__Wtkqw","rightSide":"Order_rightSide__jrYZu"};